import { render } from "./SchoolDetailComponent.vue?vue&type=template&id=145b71da&scoped=true"
import script from "./SchoolDetailComponent.vue?vue&type=script&lang=js"
export * from "./SchoolDetailComponent.vue?vue&type=script&lang=js"

import "./SchoolDetailComponent.vue?vue&type=style&index=0&id=145b71da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145b71da"]])

export default __exports__